import { render, staticRenderFns } from "./a-label.vue?vue&type=template&id=3a049173&"
import script from "./a-label.vue?vue&type=script&lang=js&"
export * from "./a-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports